import { Constants } from '@magnolia/frontend-helpers-base';

export const DefaultFallbackComponent = ({
  metadata,
  data,
}: {
  metadata: Record<string, unknown>;
  data: Record<string, unknown>;
}) => {
  const propItems = Object.entries(data).map(([key, value]) => (
    <div key={key}>{`${key}: ${formatValue(value)}`}</div>
  ));
  return (
    <div>
      <div>
        <strong>
          <em>{`Template ID: [${getTemplateId()}] is not found`}</em>
        </strong>
      </div>
      {propItems}
      <p />
    </div>
  );

  function trimIfObject(value: string): string {
    if (value === '[object Object]') {
      return '[object]';
    }
    return value;
  }

  function formatValue(value: unknown): string {
    return trimIfObject(`${value}`);
  }

  function getTemplateId(): string {
    return metadata[Constants.TEMPLATE_ID_PROP] as string;
  }
};
